import { Button, Typography } from '@mui/material';
import { useLocalization } from '@/hooks/useLocalization';
import type { AdvisorAggregatedHoldingHeldBy } from '@/store/advisorAggregatedHoldingsApi';
import { heldByLabel } from '../utils/aggregatedHoldings';

export interface HeldByCellProps {
  holders: AdvisorAggregatedHoldingHeldBy[] | undefined;
  onOpen: () => void;
  /** From the grid cell's `hasFocus`: keeps the button out of the tab
   * sequence except on the DataGrid's single active cell. */
  tabIndex: number;
}

const HeldByCell = ({ holders, onOpen, tabIndex }: HeldByCellProps) => {
  const { t } = useLocalization();

  if (!holders?.length) {
    return (
      <Typography
        variant='body2'
        color='text.secondary'
      >
        {t('common.emdash', '—')}
      </Typography>
    );
  }

  const label = heldByLabel(holders, (count) =>
    t('heldByClientsCount', { count }),
  );

  return (
    <Button
      variant='text'
      size='small'
      tabIndex={tabIndex}
      onClick={() => {
        onOpen();
      }}
      sx={{
        color: 'primary.main',
        fontWeight: '700 !important',
        textTransform: 'none',
        minWidth: 0,
        p: 0.5,
      }}
    >
      {label}
    </Button>
  );
};

export default HeldByCell;
